import { Icon } from "@iconify/react";
import { Link } from "react-router-dom";

interface InviteUnavailableNoticeProps {
  continueTo: string;
  continueLabel: string;
}

/**
 * Shown in place of the signup/sign-in form when a caregiver-invite email
 * link's token doesn't resolve to a live invite — cancelled, declined,
 * already used, or expired (see PatientSignUpPage/PatientSignInPage). Never
 * a silent fallback to an ordinary form: someone who clicked a real invite
 * link deserves to be told what happened to it.
 */
export function InviteUnavailableNotice({ continueTo, continueLabel }: InviteUnavailableNoticeProps) {
  return (
    <div className="w-full max-w-sm text-center">
      <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-[#F3F4F6]">
        <Icon icon="lucide:mail-x" className="h-6 w-6 text-[#9CA3AF]" />
      </div>
      <h2 className="text-xl font-extrabold text-[#0A2947]">This invitation is no longer available</h2>
      <p className="!mt-2 text-sm text-[#9CA3AF]">
        It may have been cancelled by the sender, already responded to, or expired.
      </p>
      <Link to={continueTo} className="mt-6 inline-block text-sm font-semibold text-[#E4002B] hover:underline">
        {continueLabel}
      </Link>
    </div>
  );
}
